/**
 * @generated SignedSource<<fedb2e550cfd62f7bec769f4a4eb2e50>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type submitBtnAgendaTeleconsultationPatientFragment$data = {
  readonly birthDate: any;
  readonly insurees: ReadonlyArray<{
    readonly activeCoverages: ReadonlyArray<{
      readonly product: {
        readonly productConfiguration: {
          readonly nursingRate: boolean | null;
        } | null;
      };
    }>;
  }>;
  readonly phoneNumber: string | null;
  readonly " $fragmentType": "submitBtnAgendaTeleconsultationPatientFragment";
};
export type submitBtnAgendaTeleconsultationPatientFragment$key = {
  readonly " $data"?: submitBtnAgendaTeleconsultationPatientFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"submitBtnAgendaTeleconsultationPatientFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "submitBtnAgendaTeleconsultationPatientFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "birthDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "insurees",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "activeCoverages",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "productConfiguration",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "nursingRate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Patient",
  "abstractKey": "__isPatient"
};

(node as any).hash = "88f0c4b9091ad61c76ee30214124b6d6";

export default node;
